import React, {Component} from 'react';
import {Dummy} from '../'

export default class EB22 extends Dummy {

    paintCanvas(cvs, disabled, power = 0, fault = 0) {
        var canvas = document.getElementById(cvs);
        if (canvas.getContext) {
            var ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = "grey";
            ctx.fillRect(0, 0, 50, 60);

            if (!disabled) {
                ctx.beginPath();
                if (fault === 0) {
                    if (power === 0) {
                        ctx.fillStyle = "red";
                    }
                    else {
                        ctx.fillStyle = "green";
                    }
                }
                else {
                    ctx.fillStyle = "orange";
                }
                ctx.arc(25, 30, 20, 0, Math.PI * 2, true); // Внешняя окружность
                ctx.fill();
                ctx.closePath();

                ctx.beginPath();
                ctx.moveTo(15, 35);
                ctx.lineTo(25, 17);
                ctx.lineTo(25, 43);
                ctx.lineTo(35, 25);
                ctx.stroke();
                ctx.closePath();
            }
        }
    };

    render() {
        return (
            <canvas className='cvs' id={this.props.canvas_id} width="50" height="60"></canvas>
        );
    }
}

EB22.propTypes = {
    canvas_id: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/entries/EB22/index.js